import { useState } from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import {
  BsDroplet,
  BsDisc,
  BsCircle,
  BsLink45Deg,
  BsFilter,
  BsLightbulb,
  BsBatteryFull,
  BsTools,
  BsLightning,
  BsExclamationTriangle,
  BsClock,
  BsChevronRight
} from "react-icons/bs";
import "../Resources/style.css";

const Services = () => {
  const [activeCategory, setActiveCategory] = useState("all");

  // Servicios definidos manualmente
  const services = [
    {
      id: "1",
      name: "Revisión de líquidos",
      description: "Chequeo y cambio del aceite del motor y líquido refrigerante",
      category: "preventivo",
      price: 15000,
      duration_minutes: 45
    },
    {
      id: "2",
      name: "Inspección de frenos",
      description: "Verificación del estado de pastillas, discos y niveles de líquido de frenos",
      category: "preventivo",
      price: 12000,
      duration_minutes: 30
    },
    {
      id: "3",
      name: "Chequeo de neumáticos",
      description: "Control de presión y estado del dibujo para asegurar estabilidad",
      category: "preventivo",
      price: 8000,
      duration_minutes: 20
    },
    {
      id: "4",
      name: "Ajuste y lubricación de cadena",
      description: "Mantener la cadena con tensión adecuada y bien lubricada",
      category: "preventivo",
      price: 10000,
      duration_minutes: 25
    },
    {
      id: "5",
      name: "Limpieza y cambio de filtros",
      description: "Revisar, limpiar o reemplazar filtros de aire y combustible",
      category: "preventivo",
      price: 12000,
      duration_minutes: 40
    },
    {
      id: "6",
      name: "Revisión de luces y bocina",
      description: "Verificar funcionamiento de faros, intermitentes, luces traseras y bocina",
      category: "preventivo",
      price: 6000,
      duration_minutes: 15
    },
    {
      id: "7",
      name: "Chequeo de batería",
      description: "Evaluar estado de la batería para garantizar arranque y funcionamiento eléctrico",
      category: "preventivo",
      price: 5000,
      duration_minutes: 10
    },
    {
      id: "8",
      name: "Sustitución de piezas desgastadas",
      description: "Cambio de pastillas de freno, bujías, partes de cadena cuando no funcionan",
      category: "correctivo",
      price: 25000,
      duration_minutes: 90
    },
    {
      id: "9",
      name: "Reparación de fallos eléctricos",
      description: "Solucionar problemas con luces o sistema de encendido",
      category: "correctivo",
      price: 20000,
      duration_minutes: 60
    },
    {
      id: "10",
      name: "Reparación de derrames de fluidos",
      description: "Investigar y reparar la causa de fugas de aceite u otros líquidos",
      category: "correctivo",
      price: 22000,
      duration_minutes: 75
    }
  ];

  // Filtrado por categoría
  const filteredServices = services.filter(service =>
    activeCategory === "all" ? true : service.category.toLowerCase() === activeCategory.toLowerCase()
  );

  const getServiceIcon = (name: string) => {
    const lower = name.toLowerCase();
    if (lower.includes("líquido") || lower.includes("aceite")) return <BsDroplet />;
    if (lower.includes("freno")) return <BsDisc />;
    if (lower.includes("neumático") || lower.includes("llanta")) return <BsCircle />;
    if (lower.includes("cadena")) return <BsLink45Deg />;
    if (lower.includes("filtro")) return <BsFilter />;
    if (lower.includes("luz") || lower.includes("bocina")) return <BsLightbulb />;
    if (lower.includes("batería")) return <BsBatteryFull />;
    if (lower.includes("eléctrico")) return <BsLightning />;
    if (lower.includes("derrame") || lower.includes("fuga")) return <BsExclamationTriangle />;
    return <BsTools />;
  };

  const getServiceImage = (name: string) => {
    const lower = name.toLowerCase();
    if (lower.includes("freno")) return "https://images.unsplash.com/photo-1629997218698-ab01760ffebf";
    if (lower.includes("neumático") || lower.includes("llanta")) return "https://images.unsplash.com/photo-1736775205983-2534f5e69212";
    if (lower.includes("cadena")) return "https://images.unsplash.com/photo-1725434696079-462c2e4af905";
    if (lower.includes("filtro") || lower.includes("mantenimiento")) return "https://images.unsplash.com/photo-1577801622187-9a1076d049da";
    if (lower.includes("eléctrico") || lower.includes("luz")) return "https://images.pexels.com/photos/4857714/pexels-photo-4857714.jpeg";
    return "https://images.unsplash.com/photo-1650569663281-44a28c984e2a";
  };

  const formatPrice = (price: number) =>
    price ? new Intl.NumberFormat("es-CR", { style: "currency", currency: "CRC", minimumFractionDigits: 0 }).format(price) : "Consultar";

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-5 bg-light">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Nuestros
            <span className="gradient-text"> Servicios</span>
          </h2>
        </div>
        <p className="info-services">En YT MotoCenter ofrecemos servicios especializados de mantenimiento preventivo y correctivo para mantener tu motocicleta en perfecto estado</p>

        <div className="text-center mb-5">

          {/* Filtros */}
          <div className="flex justify-center mb-12">
            <div className="filters-container">
              <Button
                variant={activeCategory === "all" ? "warning" : "outline-secondary"}
                onClick={() => setActiveCategory("all")}
                className="button-services px-6 py-3"
              >
                Todos los servicios
              </Button>
              <Button
                variant={activeCategory === "preventivo" ? "warning" : "outline-secondary"}
                onClick={() => setActiveCategory("preventivo")}
                className="button-services px-6 py-3"
              >
                Mantenimiento Preventivo
              </Button>
              <Button
                variant={activeCategory === "correctivo" ? "warning" : "outline-secondary"}
                onClick={() => setActiveCategory("correctivo")}
                className="button-services px-6 py-3"
              >
                Mantenimiento Correctivo
              </Button>
            </div>
          </div>

        </div>
      </Container>
      {/* Cards */}
      <Container
        className="services-container"
        style={{ maxWidth: '1280px', marginLeft: 'auto', marginRight: 'auto', paddingLeft: '1rem', paddingRight: '1rem' }}
      >
        <Row className="g-4">
          {filteredServices.map(service => (
            <Col xs={12} md={6} lg={4} key={service.id}>
              <Card className="h-100 shadow-sm rounded-4 service-card">

                <div className="position-relative" style={{ height: '180px', overflow: 'hidden', borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem' }}>
                  <Card.Img
                    src={getServiceImage(service.name)}
                    alt={service.name}
                    className="w-100 h-100 service-card-img"
                    style={{ objectFit: 'cover', transition: 'transform 0.3s' }}
                  />
                  <div className="position-absolute top-2 start-2 bg-white rounded p-2 d-flex align-items-center justify-content-center">
                    {getServiceIcon(service.name)}
                  </div>
                  <Badge
                    className="position-absolute top-2 end-2"
                    style={{
                      backgroundColor: '#d1fae5',
                      color: '#065f46',
                      fontSize: '0.75rem',
                      padding: '0.25rem 0.5rem',
                      borderRadius: '9999px'
                    }}
                  >
                    {service.category === 'preventivo' ? 'Preventivo' : 'Correctivo'}
                  </Badge>
                </div>

                {/* Cuerpo de la card */}
                <Card.Body>
                  <Card.Title className="fw-bold">{service.name}</Card.Title>
                  <div className="d-flex align-items-center mb-2">
                    <div className="me-2">{getServiceIcon(service.name)}</div>
                    <Badge className="px-3 py-1 rounded-pill fw-medium"
                      style={{ fontSize: '0.875rem', backgroundColor: '#b3f8d4ff ', color: 'white' }}
                      bg={service.category === "preventivo" ? "success" : "primary"}>
                      {service.category === "preventivo" ? "Preventivo" : "Correctivo"}
                    </Badge>
                  </div>
                  <Card.Text className="text-muted">{service.description}</Card.Text>
                  <div className="d-flex align-items-center mt-2 gap-3 text-muted">
                    <div className="d-flex align-items-center">
                      <BsClock className="me-1" /> {service.duration_minutes} min
                    </div>
                    <div className="d-flex align-items-center fw-semibold" style={{ color: '#ea580c' }}>
                      {formatPrice(service.price)}
                    </div>
                  </div>
                </Card.Body>

                {/* Botón */}
                <Card.Footer className="bg-white border-0 pt-0">
                  <Button
                    onClick={scrollToContact}
                    className="w-100 mt-3 text-white"
                    style={{
                      background: 'linear-gradient(90deg, #f97316, #ea580c)',
                      border: 'none',
                      fontWeight: 600,
                      padding: '0.75rem 1rem'
                    }}
                    onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.03)')}
                    onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
                  >
                    Agendar Servicio <BsChevronRight className="ms-2" />
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>

      </Container>
      {/* Call to Action */}

      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={12}>
            <div className="contact-card">
              <h3>¿No encuentras el servicio que necesitas?</h3>
              <p>
                Contáctanos y te ayudaremos con cualquier problema o mantenimiento específico de tu motocicleta
              </p>
              <Button className="contact-btn" onClick={scrollToContact}>
                Contactar Ahora
              </Button>
            </div>
          </Col>
        </Row>
      </Container>


    </section>
  );
};

export default Services;
